// scheduling/components/ExperienceRankingList.jsx
// Ranked staff list for one experience dimension (client / niche / serviceline),
// sorted by percentile. Shared by the EmployeeProfile ranking modal and the
// ClientView "Experience" tab. Rows are clickable → staff profile.
import { BRAND, getExpLevel } from '../utils/schedConstants';

export default function ExperienceRankingList({ rows = [], loading = false, highlightStaffId = null, onStaffClick }) {
  if (loading) return <div style={{ padding: 24, textAlign: 'center', color: '#9CA3AF' }}>Loading rankings...</div>;
  if (!rows.length) return <div style={{ padding: 24, textAlign: 'center', color: '#9CA3AF' }}>No staff with experience in this dimension.</div>;
  return (
    <div style={{ maxHeight: 500, overflowY: 'auto' }}>
      {rows.map((r, i) => {
        const expLevel = getExpLevel(r.Percentile);
        const isHighlight = highlightStaffId != null && String(r.StaffId) === String(highlightStaffId);
        const topPct = r.Percentile != null ? Math.max(1, Math.round(100 - r.Percentile)) : null;
        return (
          <div key={r.StaffId} style={{
            display: 'flex', alignItems: 'center', gap: 10, padding: '8px 10px',
            borderBottom: '1px solid #F3F4F6', cursor: onStaffClick ? 'pointer' : 'default',
            background: isHighlight ? '#EFF6FF' : 'transparent',
          }}
            onClick={onStaffClick ? () => onStaffClick(r.StaffId) : undefined}>
            <div style={{ width: 28, height: 28, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: 11, fontWeight: 800, color: i < 3 ? '#fff' : '#6B7280',
              background: i === 0 ? BRAND.deepTeal : i === 1 ? BRAND.oceanBlue : i === 2 ? '#74A282' : '#F3F4F6' }}>
              #{i + 1}
            </div>
            <div style={{ width: 30, height: 30, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: 10, fontWeight: 700, color: '#fff', background: expLevel.color, flexShrink: 0 }}>
              {r.Initials || '??'}
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontSize: 13, fontWeight: 600, color: '#111827' }}>
                {r.Name}
                {isHighlight && <span style={{ fontSize: 10, color: '#3B82F6', marginLeft: 4 }}>(this staff)</span>}
                {r.IsManualOverride ? <span style={{ fontSize: 9, color: '#D97706', marginLeft: 4 }}>&#9998;</span> : null}
              </div>
              <div style={{ fontSize: 11, color: '#6B7280' }}>{r.Level} &middot; {r.Department || r.DepartmentCode}</div>
            </div>
            <div style={{ textAlign: 'right', flexShrink: 0 }}>
              <div style={{ fontSize: 12, fontWeight: 700, color: expLevel.color }}>{expLevel.label}</div>
              <div style={{ fontSize: 10, color: '#9CA3AF' }}>
                {Math.round(r.TotalHours || 0)}h
                {topPct != null && <> &middot; top {topPct}%</>}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
